// The page's elements, as the modules that draw it find them: index.html's
// <main id="app">, which every page is drawn into, and a way to find any
// other element the page must have.

// An element the page always has, of the kind `type` (HTMLElement,
// SVGElement…): index.html's, or one the page just drew. Missing, or of
// another kind, means the HTML and this script disagree, so it says which.
export function element<T extends Element>(
  selector: string,
  type: abstract new (...args: never[]) => T,
  root: ParentNode = document
): T {
  const found = root.querySelector(selector);
  if (!(found instanceof type)) throw new Error(`dom.ts: no ${type.name} ${selector}`);
  return found;
}

// The element matching `selector` that an event happened in, if any.
export const eventTarget = <T extends Element = HTMLElement>(event: Event, selector: string): T | null =>
  event.target instanceof Element ? event.target.closest<T>(selector) : null;

export const app = element("#app", HTMLElement);
